import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import type { CashDepositOrderRes } from '@/types/api/deposit-payment/cash-deposit-order.d.ts';

export const getCashDepositOrder = ({ order_id }: { order_id: string; }) =>
  get<CashDepositOrderRes>('/wallet/v1/cash/deposit_order', {
    params: { order_id },
  });

const { getQueryOptions, useQueryHook } = createApiQuery(getCashDepositOrder, (params) => ['cash-deposit-order', params.order_id]);

export const getCashDepositOrderQueryOptions = getQueryOptions;
export const useGetCashDepositOrder = useQueryHook;
